'use client';

import Container from '@mui/material/Container';
import {Section} from '../primitives';
import {CardGridSkeleton} from './CardGridSkeleton';
import {MastheadSkeleton} from './MastheadSkeleton';
import {SectionHeadingSkeleton} from './SectionHeadingSkeleton';

// Country detail is its own design — NOT the hero-gallery + summary + carousel
// shell of the other detail pages. It's a BannerCard masthead (160/350) over
// a "Projects" heading and a paginated card grid, so its skeleton mirrors that.
export function CountryDetailPageSkeleton() {
  return (
    <>
      <MastheadSkeleton mobileHeight={160} desktopHeight={350} />
      <Section>
        <Container>
          <SectionHeadingSkeleton />
          <CardGridSkeleton />
        </Container>
      </Section>
    </>
  );
}

CountryDetailPageSkeleton.displayName = 'CountryDetailPageSkeleton';
